import * as React from 'react';
import { Text } from '@doordash/design-language';
import { ProgressContainer, StatusBarContainer, FullWidthBar, CurrentStatusBar, } from '../QuizV2Styles';
export var ProgressBar = function (_a) {
    var currentQuizStep = _a.currentQuizStep, numberOfQuestions = _a.numberOfQuestions;
    return (React.createElement(ProgressContainer, null,
        React.createElement(Text, null,
            currentQuizStep + 1,
            "/",
            numberOfQuestions),
        React.createElement(StatusBarContainer, null,
            React.createElement(FullWidthBar, null,
                React.createElement(CurrentStatusBar, { status: (currentQuizStep + 1) / numberOfQuestions })))));
};
